module.exports = __webpack_public_path__ + "vn.bb49d60066f6fda3d12d.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/vn.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/vn.svg
// module chunks = styles